/**
 * Copyright (c) Investec
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 */

import { generateSettingsContainerApp } from "./generateSettingsContainerApp.js";
import { generateSettingsFunctionApp } from "./generateSettingsFunctionApp.js";
import {
  getBranchResources,
  getResourceNameAndKeyVaultResourceName,
} from "./getBranchResources.js";

export {
  generateSettingsContainerApp,
  generateSettingsFunctionApp,
  getBranchResources,
  getResourceNameAndKeyVaultResourceName,
};
